import { Injectable, inject } from '@angular/core';
import { mergeMap } from 'rxjs/operators';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { DevicesService, InstalledApplication } from '@era/locations-sdk';
import {
  InstalledApplicationsResolverActions,
  InstalledApplicationsApiActions,
} from './installed-applications.actions';
import { safeMap } from '../effects.helpers';

@Injectable()
export class InstalledApplicationsEffects {
  private readonly devicesServices = inject(DevicesService);
  private readonly actions$ = inject(Actions);

  installedApplicationsLoadedEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(InstalledApplicationsResolverActions.installedApplicationsRequested),
      mergeMap(() =>
        safeMap(
          this.devicesServices.getInstalledApplications(),
          (installedApplications: InstalledApplication[]) =>
            InstalledApplicationsApiActions.installedApplicationsLoaded({ installedApplications }),
          (error) => InstalledApplicationsApiActions.installedApplicationsLoadedError({ error })
        )
      )
    );
  });
}
